import { defineStore } from 'pinia'
import { ref } from 'vue'
import { resultsViewModeTypes } from 'Shared'
import viewTypes from '../../features/ViewState/types/viewTypes'
import { persistPiniaSlice, loadPiniaSlice } from '../persist'

export const useViewStateStore = defineStore('viewState', () => {
    const isRealTest = ref(false)
    const testStartedAlready = ref(false)
    const isTestOver = ref(false)
    const currentView = ref(viewTypes.none)
    const inResultsMode = ref(false)
    const viewMode = ref(resultsViewModeTypes.summary)

    const persist = () => {
        persistPiniaSlice('viewStateStore', {
            isRealTest: isRealTest.value,
            testStartedAlready: testStartedAlready.value,
            isTestOver: isTestOver.value,
            currentView: currentView.value,
            inResultsMode: inResultsMode.value,
            viewMode: viewMode.value,
        })
    }

    const applyResetTestState = (realTest = false) => {
        isRealTest.value = realTest
        testStartedAlready.value = false
        isTestOver.value = false
        currentView.value = realTest ? viewTypes.testIntro : viewTypes.none
        inResultsMode.value = false
        viewMode.value = resultsViewModeTypes.summary
    }

    const configureRealTest = (realTest) => {
        applyResetTestState(realTest)
        persist()
    }

    const resetTestState = () => {
        applyResetTestState()
        persist()
    }

    const startTest = ({ isRealTest: realTest = false } = {}) => {
        applyResetTestState(realTest)
        testStartedAlready.value = true
        persist()
    }

    const endTest = () => {
        isTestOver.value = true
        persist()
    }

    const changeIsResultsModeTo = (isResultsMode) => {
        inResultsMode.value = isResultsMode
        persist()
    }

    const changeViewModeTo = (newViewMode) => {
        viewMode.value = newViewMode
        persist()
    }

    const changeViewTypeTo = (viewType) => {
        currentView.value = viewType
        persist()
    }

    const loadFromLocalStorage = () => {
        const slice = loadPiniaSlice('viewStateStore')
        if (!slice) return
        if (typeof slice.isRealTest === 'boolean') {
            isRealTest.value = slice.isRealTest
        }
        if (typeof slice.testStartedAlready === 'boolean') {
            testStartedAlready.value = slice.testStartedAlready
        }
        if (typeof slice.isTestOver === 'boolean') {
            isTestOver.value = slice.isTestOver
        }
        if (slice.currentView !== undefined) {
            currentView.value = slice.currentView
        }
        if (typeof slice.inResultsMode === 'boolean') {
            inResultsMode.value = slice.inResultsMode
        }
        if (slice.viewMode !== undefined) {
            viewMode.value = slice.viewMode
        }
    }

    loadFromLocalStorage()

    return {
        isRealTest,
        testStartedAlready,
        isTestOver,
        currentView,
        inResultsMode,
        viewMode,

        configureRealTest,
        resetTestState,
        startTest,
        endTest,
        changeIsResultsModeTo,
        changeViewModeTo,
        changeViewTypeTo,
    }
})
